module.exports = __webpack_public_path__ + "static/immortalis-15e15430464f729fee1dfd6f04edad46.svg";